/* Artwork Product V14 - full artwork primary + two room thumbnails; collection video remains separate */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-artwork-product]').forEach(function (root) {
    var thumbs = root.querySelectorAll('[data-artwork-thumb]');
    var mediaItems = root.querySelectorAll('[data-artwork-media]');
    var optionInputs = root.querySelectorAll('input[data-artwork-option]');
    var variantInput = root.querySelector('[data-variant-id]');
    var addButton = root.querySelector('[data-add-to-cart]');
    var addText = root.querySelector('[data-add-to-cart-text]');
    var variantsScript = root.querySelector('[data-artwork-variants]');
    var qtyInput = root.querySelector('.artwork-product__qty-input');
    var minusButton = root.querySelector('[data-qty-minus]');
    var plusButton = root.querySelector('[data-qty-plus]');
    var finishHelpToggle = root.querySelector('[data-finish-help-toggle]');
    var finishHelp = root.querySelector('[data-finish-help]');

    var viewArtworkButton = root.querySelector('[data-view-artwork]');

    function showMedia(mediaId, activeThumb) {
      thumbs.forEach(function (item) {
        item.classList.remove('is-active');
        item.removeAttribute('aria-current');
      });

      mediaItems.forEach(function (item) {
        var active = item.getAttribute('data-media-id') === mediaId;
        item.hidden = !active;
        item.classList.toggle('is-active', active);
      });

      if (viewArtworkButton) {
        viewArtworkButton.classList.remove('is-active');
        viewArtworkButton.removeAttribute('aria-current');
      }

      if (activeThumb) {
        activeThumb.classList.add('is-active');
        activeThumb.setAttribute('aria-current', 'true');
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb.getAttribute('data-media-id'), thumb);
      });
    });

    if (viewArtworkButton) {
      viewArtworkButton.addEventListener('click', function () {
        showMedia(viewArtworkButton.getAttribute('data-media-id'), null);
        viewArtworkButton.classList.add('is-active');
        viewArtworkButton.setAttribute('aria-current', 'true');
      });
    }

    if (minusButton && qtyInput) {
      minusButton.addEventListener('click', function () {
        var current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = Math.max(1, current - 1);
      });
    }

    if (plusButton && qtyInput) {
      plusButton.addEventListener('click', function () {
        var current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = current + 1;
      });
    }

    if (finishHelpToggle && finishHelp) {
      finishHelpToggle.addEventListener('click', function () {
        var isOpen = finishHelpToggle.getAttribute('aria-expanded') === 'true';
        finishHelpToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        finishHelp.hidden = isOpen;
      });
    }

    if (!variantsScript || !optionInputs.length) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      console.error('Artwork variant data could not be read.', e);
      return;
    }

    function selectedByPosition() {
      var selections = {};
      optionInputs.forEach(function (input) {
        if (input.checked) {
          selections[Number(input.getAttribute('data-option-position'))] = input.value;
        }
      });
      return selections;
    }

    function findVariantForSize(sizeInput, selections) {
      var sizePosition = Number(sizeInput.getAttribute('data-option-position'));
      var sizeValue = sizeInput.value;

      return variants.find(function (variant) {
        return variant.options.every(function (optionValue, index) {
          var position = index + 1;

          if (position === sizePosition) {
            return optionValue === sizeValue;
          }

          if (Object.prototype.hasOwnProperty.call(selections, position)) {
            return optionValue === selections[position];
          }

          return true;
        });
      });
    }

    function updateSizePrices() {
      var selections = selectedByPosition();
      var sizeInputs = root.querySelectorAll('input[data-option-kind="size"]');

      sizeInputs.forEach(function (sizeInput) {
        var label = sizeInput.closest('.artwork-product__size-choice');
        if (!label) return;

        var priceEl = label.querySelector('[data-size-price]');
        if (!priceEl) return;

        var variant = findVariantForSize(sizeInput, selections);

        if (!variant) {
          priceEl.textContent = 'Unavailable';
          sizeInput.disabled = true;
          label.classList.add('is-unavailable');
          return;
        }

        priceEl.textContent = variant.available ? variant.formatted_price : 'Sold out';
        sizeInput.disabled = !variant.available;
        label.classList.toggle('is-unavailable', !variant.available);
      });

      var selectedSize = root.querySelector('input[data-option-kind="size"]:checked');
      if (selectedSize && selectedSize.disabled) {
        selectedSize.checked = false;
      }

      if (!root.querySelector('input[data-option-kind="size"]:checked')) {
        var firstAvailable = Array.from(
          root.querySelectorAll('input[data-option-kind="size"]')
        ).find(function (input) {
          return !input.disabled;
        });

        if (firstAvailable) {
          firstAvailable.checked = true;
        }
      }
    }

    function updateSelectedVariant() {
      updateSizePrices();

      var selections = selectedByPosition();

      var variant = variants.find(function (item) {
        return item.options.every(function (optionValue, index) {
          var position = index + 1;
          return selections[position] === optionValue;
        });
      });

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }

      if (variantInput) {
        var previousVariantId = String(variantInput.value);
        variantInput.value = variant.id;

        if (previousVariantId !== String(variant.id)) {
          variantInput.dispatchEvent(new Event('input', { bubbles: true }));
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (addButton) {
        addButton.disabled = !variant.available;
      }

      if (addText) {
        addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }

    // Prefer Stretched Canvas when that finish exists.
    var finishInputs = Array.from(
      root.querySelectorAll('input[data-option-kind="finish"]')
    );

    var stretchedInput = finishInputs.find(function (input) {
      return input.value.toLowerCase().indexOf('stretched') !== -1;
    });

    if (stretchedInput) {
      stretchedInput.checked = true;
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateSelectedVariant);
    });

    updateSelectedVariant();
  });
});
